// src/components/admin/settings/SettingsLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import './SettingsLayout.css';

const SettingsLayout = () => {
  console.log('SettingsLayout is rendering');
  return (
    <div className="settings-layout">
      <div className="settings-header">
        <h1>Settings</h1>
        <p>Manage your store configuration</p>
      </div>
      <div className="settings-content">
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsLayout;